import { Tabs } from 'antd'
import Cascader from 'antd/lib/cascader'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import shallow from 'zustand/shallow'
import { searchOptionsFilter } from '../../../components/custom_components/Cascader/util'
import { useCascaderSearchOnOpen } from '../../../components/custom_components/Cascader/useCascaderSearchOnOpen'
import { PerTabBarContent } from '../../../components/custom_components/TabBarContent'
import { useAuth } from '../../../context/auth-context'
import { getCompanySettingsPermissionInfo } from '../../../shared/permissions/permission-helper'
import { Country, RoleName } from '../../../types'
import '../index.less'
import { CompanySettingsPermissions } from '../permissions'
import { useHrSupportStore } from './HrSupportStore'
import { HrSupportTabs } from './types'

const { TabPane } = Tabs

export const HrSupportHeader: FC = () => {
  const { t } = useTranslation()
  const { user } = useAuth()
  const isHrAdminIta = user.roles?.includes(RoleName.HrAdminIta) || false

  const [activeTab, setActiveTab, selected, setSelected, selectableCountries] = useHrSupportStore(
    (state) => [state.activeTab, state.setActiveTab, state.selected, state.setSelected, state.selectableCountries],
    shallow,
  )

  const companySettingsPermissionInfo = getCompanySettingsPermissionInfo(user.roles ? user.roles : [])
  const { cascaderRef, cascaderClassName, searchPlaceholder, onPopupVisibleChange } = useCascaderSearchOnOpen(
    t('companySettingsView.countryCascaderSearchPlaceholder'),
  )

  const onDropDownChanged = (values: string[]) => {
    setSelected(values[0] as Country)
  }

  return (
    <PerTabBarContent
      tabs={
        <Tabs
          tabBarStyle={{ maxWidth: 750 }}
          activeKey={activeTab}
          onChange={(key) => {
            setActiveTab(key)
            if (key === HrSupportTabs.nationalContractReference) {
              setSelected(Country.Ita)
            }
          }}
        >
          {companySettingsPermissionInfo[CompanySettingsPermissions.hrFeedbackTab] && (
            <TabPane tab={t('companySettingsView.feedbackTab.heading')} key={HrSupportTabs.feedback} />
          )}
          {companySettingsPermissionInfo[CompanySettingsPermissions.hrBusinessPartnersTab] && (
            <TabPane tab={t('companySettingsView.hrBusinessPartnersTab.heading')} key={HrSupportTabs.hrbusinessPartner} />
          )}
          {companySettingsPermissionInfo[CompanySettingsPermissions.hrCountrySettingsTab] && (
            <TabPane tab={t('companySettingsView.countrySettingsTab.heading')} key={HrSupportTabs.countrySettings} />
          )}
          {isHrAdminIta && companySettingsPermissionInfo[CompanySettingsPermissions.hrNationalContractReferenceTab] && (
            <TabPane tab={t('companySettingsView.nationalContractReferenceTab.heading')} key={HrSupportTabs.nationalContractReference} />
          )}
        </Tabs>
      }
      actions={
        <Cascader
          ref={cascaderRef}
          className={cascaderClassName}
          options={selectableCountries}
          onChange={onDropDownChanged}
          placeholder={searchPlaceholder}
          allowClear={false}
          disabled={activeTab === HrSupportTabs.nationalContractReference}
          value={[selected.label, selected.value, selected.key]}
          style={{ width: '40%', marginLeft: '3.5px' }}
          showSearch={{ filter: searchOptionsFilter }}
          onPopupVisibleChange={onPopupVisibleChange}
        />
      }
    />
  )
}
